import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapePreparation extends Shape {
    width = 200;
    height = 182;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();

        const r = height / 150;

        canv.ctx.moveTo(x + width / 4 + r, y);
        canv.ctx.arcTo(x + (width * 3) / 4, y, x + width, y + height / 2, r);
        canv.ctx.arcTo(x + width, y + height / 2, x + (width * 3) / 4, y + height, r);
        canv.ctx.arcTo(x + (width * 3) / 4, y + height, x + width / 4, y + height, r);
        canv.ctx.arcTo(x + width / 4, y + height, x, y + height / 2, r);
        canv.ctx.arcTo(x, y + height / 2, x + width / 4, y, r);
        canv.ctx.arcTo(x + width / 4, y, x + (width * 3) / 4, y, r);
        canv.ctx.arcTo(x + width / 4 + r, y, x + (width * 3) / 4, y, r);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="m5.76 2.45-4.67 9.16a.87.87 0 0 0 0 .78l4.67 9.16c.14.28.42.45.73.45h10.6c.3 0 .57-.16.71-.43l5.1-9.15a.87.87 0 0 0 0-.84l-5.1-9.15A.82.82 0 0 0 17.1 2H6.49c-.31 0-.6.17-.73.45Z"/>
            </svg>
        `;
    }
}
